// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoDialogTemplate_title_1pYAf","content":"InfoDialogTemplate_content_2LYJh","button":"InfoDialogTemplate_button_3g2W9"};